// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_H_f","cls2":"FeedbackPopover-cls2_lFG FeedbackPopover-cls1_H_f"};